/**
 * Nhật ký hoạt động: phân loại kết quả một lần chạy và bộ lọc (kết quả · thời
 * lượng · khoảng ngày) — dùng chung cho hộp Nhật ký trong trình dựng luồng và
 * tab Nhật ký ở danh sách.
 */
import type { WorkflowRun } from './types'

export type KetQuaChay = 'dang_chay' | 'thanh_cong' | 'that_bai' | 'mot_phan' | 'bo_qua'
export const KET_QUA_LABELS: Record<KetQuaChay, { ten: string; mau: 'success' | 'destructive' | 'warning' | 'secondary' }> = {
  dang_chay: { ten: 'Đang chạy', mau: 'secondary' },
  thanh_cong: { ten: 'Thành công', mau: 'success' },
  that_bai: { ten: 'Không thành công', mau: 'destructive' },
  mot_phan: { ten: 'Thành công một phần', mau: 'warning' },
  bo_qua: { ten: 'Đã huỷ kích hoạt', mau: 'secondary' },
}

/** Bỏ qua = khối Kích hoạt không khớp sự kiện / không thoả lọc "Chỉ khi". */
export function ketQuaLanChay(r: WorkflowRun): KetQuaChay {
  if (r.status === 'running' || r.status === 'waiting') return 'dang_chay'
  const nguon = r.steps.find((s) => s.kind === 'source')
  if (nguon?.status === 'skip') return 'bo_qua'
  if (r.status === 'fail') return r.steps.some((s) => s.kind !== 'source' && s.status === 'ok') ? 'mot_phan' : 'that_bai'
  return 'thanh_cong'
}

export type ThoiLuong = 'all' | 'duoi_1_phut' | 'duoi_1_gio' | 'duoi_1_ngay' | 'tren_1_ngay'
export const THOI_LUONG_LABELS: Record<ThoiLuong, string> = {
  all: 'Mọi thời lượng', duoi_1_phut: 'Dưới 1 phút', duoi_1_gio: '1 phút – 1 giờ', duoi_1_ngay: '1 giờ – 1 ngày', tren_1_ngay: 'Trên 1 ngày',
}
const PHUT = 60_000, GIO = 3_600_000, NGAY = 86_400_000

export function trongThoiLuong(ms: number, t: ThoiLuong): boolean {
  switch (t) {
    case 'duoi_1_phut': return ms < PHUT
    case 'duoi_1_gio': return ms >= PHUT && ms < GIO
    case 'duoi_1_ngay': return ms >= GIO && ms < NGAY
    case 'tren_1_ngay': return ms >= NGAY
    default: return true
  }
}

export function moTaThoiLuong(ms: number): string {
  if (!ms) return 'tức thì'
  if (ms < GIO) return `${Math.round(ms / PHUT)} phút`
  if (ms < NGAY) return `${+(ms / GIO).toFixed(1)} giờ`
  return `${+(ms / NGAY).toFixed(1)} ngày`
}

export interface BoLocNhatKy {
  ketQua: KetQuaChay[]
  thoiLuong: ThoiLuong
  /** yyyy-mm-dd, bao gồm cả hai đầu. */
  tu: string
  den: string
  workflowId?: string
}

export const ngayISO = (d: Date) => d.toISOString().slice(0, 10)
export const locMacDinh = (workflowId?: string): BoLocNhatKy => ({
  ketQua: Object.keys(KET_QUA_LABELS) as KetQuaChay[],
  thoiLuong: 'all',
  tu: ngayISO(new Date(Date.now() - 6 * NGAY)),
  den: ngayISO(new Date()),
  workflowId,
})

export function locLanChay(runs: WorkflowRun[], f: BoLocNhatKy): WorkflowRun[] {
  return runs.filter((r) => {
    if (f.workflowId && r.workflowId !== f.workflowId) return false
    const ngay = r.startedAt.slice(0, 10)
    if (f.tu && ngay < f.tu) return false
    if (f.den && ngay > f.den) return false
    if (!trongThoiLuong(r.durationMs ?? 0, f.thoiLuong)) return false
    return f.ketQua.includes(ketQuaLanChay(r))
  })
}
